// components/public/ProductCard.jsx
import React from 'react';

const ProductCard = ({ producto, whatsappNumber }) => {
  // Construir URL de imagen correctamente
  const getImageUrl = () => {
    if (!producto.imagen) return null;
    
    // Si la imagen ya es una URL completa (http/https)
    if (producto.imagen.startsWith('http')) {
      return producto.imagen;
    }
    
    // Si es una ruta relativa, construir URL completa
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000';
    return `${apiUrl}${producto.imagen}`;
  };

  const imageUrl = getImageUrl();

  // Función para abrir WhatsApp con mensaje predefinido
  const handleOrdenar = () => {
    if (!whatsappNumber) {
      alert('Número de WhatsApp no disponible');
      return;
    }

    // Limpiar el número de WhatsApp (quitar espacios, guiones, paréntesis, etc.)
    let cleanNumber = whatsappNumber.replace(/\D/g, '');
    
    // Si el número empieza con 0 (formato local ecuatoriano), convertir a formato internacional
    if (cleanNumber.startsWith('0')) {
      cleanNumber = '593' + cleanNumber.substring(1);
    }
    
    // Si no tiene código de país y tiene 9 dígitos, agregar el de Ecuador (593)
    if (cleanNumber.length === 9) {
      cleanNumber = '593' + cleanNumber;
    }
    
    console.log('Número original:', whatsappNumber);
    console.log('Número limpio:', cleanNumber);
    
    // Crear mensaje predefinido
    const mensaje = `Hola! Me interesa ordenar: *${producto.nombre}* - $${Number(producto.precio || 0).toFixed(2)}`;
    
    // Codificar el mensaje para URL
    const mensajeCodificado = encodeURIComponent(mensaje);
    
    // Abrir WhatsApp
    const whatsappUrl = `https://wa.me/${cleanNumber}?text=${mensajeCodificado}`;
    console.log('URL de WhatsApp:', whatsappUrl);
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
      {/* Imagen del producto */}
      <div className="relative h-64 bg-gradient-to-br from-red-50 to-orange-50 overflow-hidden">
        {imageUrl && (
          <img
            src={imageUrl}
            alt={producto.nombre}
            className="w-full h-full object-cover"
          />
        )}
        
        {/* Badge de categoría */}
        {producto.categoria && (
          <div className="absolute top-4 left-4">
            <span className="bg-red-600 text-white px-3 py-1 rounded-full text-xs font-semibold shadow-md">
              {producto.categoria.nombre}
            </span>
          </div>
        )}
      </div>

      {/* Contenido */}
      <div className="p-6">
        <h3 className="text-xl font-bold text-gray-900 mb-2">
          {producto.nombre}
        </h3>
        
        <p className="text-gray-600 text-sm mb-4 line-clamp-2">
          {producto.descripcion || 'Delicioso producto preparado con ingredientes frescos'}
        </p>

        {/* Precio y botón */}
        <div className="flex items-center justify-between">
          <div className="text-2xl font-bold text-red-600">
            ${Number(producto.precio || 0).toFixed(2)}
          </div>
          
          <button 
            onClick={handleOrdenar}
            className="bg-red-600 text-white px-6 py-2 rounded-full hover:bg-red-700 transition-colors font-semibold shadow-md hover:shadow-lg"
          >
            Ordenar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
